import { render, staticRenderFns } from "./exaTask.vue?vue&type=template&id=4ddf3c2e&scoped=true&"
import script from "./exaTask.vue?vue&type=script&lang=js&"
export * from "./exaTask.vue?vue&type=script&lang=js&"
import style0 from "./exaTask.vue?vue&type=style&index=0&id=4ddf3c2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf3c2e",
  null
  
)

export default component.exports